var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSampleGroupProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_25919_15912)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23 46C35.7025 46 46 35.7025 46 23C46 10.2975 35.7025 0 23 0C10.2975 0 0 10.2975 0 23C0 35.7025 10.2975 46 23 46Z",
    fill: "#E4E8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 13C20.38 13 18.25 15.13 18.25 17.75C18.25 20.32 20.26 22.4 22.88 22.49C22.96 22.48 23.04 22.48 23.1 22.49C23.12 22.49 23.13 22.49 23.15 22.49C23.16 22.49 23.16 22.49 23.17 22.49C25.73 22.4 27.74 20.32 27.75 17.75C27.75 15.13 25.62 13 23 13Z",
    fill: "#5A7FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0809 25.1509C25.2909 23.2909 20.7409 23.2909 17.9309 25.1509C16.6609 26.0009 15.9609 27.1509 15.9609 28.3809C15.9609 29.6109 16.6609 30.7509 17.9209 31.5909C19.3209 32.5309 21.1609 33.0009 23.0009 33.0009C24.8409 33.0009 26.6809 32.5309 28.0809 31.5909C29.3409 30.7409 30.0409 29.6009 30.0409 28.3609C30.0309 27.1309 29.3409 25.9909 28.0809 25.1509Z",
    fill: "#5A7FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.9795 18.106C33.1153 19.9977 31.9443 21.6554 30.3237 21.8797C30.3152 21.8797 30.3152 21.8797 30.3067 21.8797H30.2812C30.2303 21.8797 30.1794 21.8797 30.137 21.8992C29.3139 21.9479 28.5587 21.6457 27.9902 21.0898C28.8642 20.1927 29.3648 18.8471 29.263 17.3844C29.2036 16.5946 28.966 15.873 28.6097 15.2587C28.9321 15.0734 29.3054 14.9564 29.6873 14.9174C31.3504 14.7517 32.8353 16.1753 32.9795 18.106Z",
    fill: "#5A7FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0107 18.2017C12.8749 20.0934 14.0459 21.7511 15.6666 21.9754C15.6751 21.9754 15.6751 21.9754 15.6835 21.9754H15.709C15.7599 21.9754 15.8108 21.9754 15.8532 21.9949C16.6763 22.0436 17.4315 21.7414 18 21.1855C17.126 20.2885 16.6254 18.9428 16.7272 17.4801C16.7866 16.6903 17.0242 15.9687 17.3806 15.3544C17.0581 15.1691 16.6848 15.0521 16.303 15.0131C14.6399 14.8474 13.155 16.271 13.0107 18.2017Z",
    fill: "#5A7FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.9807 27.4161C34.9108 28.4861 34.369 29.4126 33.4603 30.0414C32.5865 30.648 31.4855 30.9348 30.3932 30.9017C31.0224 30.1848 31.3893 29.2913 31.4593 28.3427C31.5466 26.9749 31.0311 25.6623 30 24.6144C29.4145 24.0298 28.733 23.5666 27.9902 23.2246C29.9214 22.5187 32.3505 22.993 33.8448 24.5152C34.6487 25.3314 35.0593 26.3572 34.9807 27.4161Z",
    fill: "#5A7FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0095 27.5118C11.0794 28.5818 11.6212 29.5083 12.53 30.1371C13.4038 30.7437 14.5048 31.0305 15.597 30.9974C14.9679 30.2805 14.6009 29.387 14.531 28.4384C14.4436 27.0706 14.9591 25.758 15.9902 24.7101C16.5757 24.1255 17.2573 23.6623 18 23.3203C16.0689 22.6144 13.6397 23.0887 12.1455 24.6109C11.3416 25.4271 10.9309 26.4529 11.0095 27.5118Z",
    fill: "#5A7FFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_25919_15912"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSampleGroupProfile);
export default __webpack_public_path__ + "static/media/sample-group-profile.7218fe7c718ec812103b6c9f39211ae6.svg";
export { ForwardRef as ReactComponent };